define([
    'language/resource',
    'authui/iamUtils',
    'base/utils/cookie',
    'base/utils/utility',
    'base/utils/iamHttpService',
    'base/utils/preVerifycodeUtilNew',
    'base/widgets/graphicVerifyWindow/window',
], function (i18n, iamUtils, cookieOp, utils, iamHttpService, perVerifycodeUtilNew, GrahicVerifyWindow) {
    'use strict';

    function SsologinController($scope, securityPolicy, $compile, $interval, $state) {
        $scope.i18n = i18n;
        document.title = i18n('titles.login');
        $scope.model = {
            redirectUrl: '',
            ssoType: '',
            xUserId: '',
            domainList: [],
            selectedDomain: '',
            selectedId: '',
            select: function (domain, id) {
                $scope.model.selectedDomain = domain;
                $scope.model.selectedId = id;
            },
            btnClick: function () {
                if (!$scope.model.selectedDomain || !$scope.model.selectedId) return;
                var selectedDomain = encodeURIComponent($scope.model.selectedDomain);
                var selectedId = encodeURIComponent($scope.model.selectedId);
                var url = `https://${window.LOGIN_CONFIG.AUTH_DOMAIN}/authui/multi-tenant/samlLogin?domain_id=` + selectedDomain + '&idp_id=' + selectedId;
                if ($scope.model.redirectUrl) {
                    url += '&redirect_url=' + encodeURIComponent($scope.model.redirectUrl);
                }
                if ($scope.model.ssoType) {
                    url += '&sso_type=' + $scope.model.ssoType;
                }
                if ($scope.model.xUserId) {
                    url += '&xuser_id=' + $scope.model.xUserId;
                }
                window.location.href = url;
            }
        }

        initPage($scope);
    };

    function initPage($scope) {
        $scope.model.redirectUrl = iamUtils.getUrlParams()['redirect_url'];
        $scope.model.ssoType = iamUtils.getUrlParams()['sso_type'];
        $scope.model.xUserId = iamUtils.getUrlParams()['xuser_id'];
        var idpJsonStr = iamUtils.getUrlParams()['idp'];
        idpJsonStr = decodeURIComponent(idpJsonStr);
        var domainList;
        try {
            domainList = JSON.parse(idpJsonStr);
        } catch (e) {
            iamUtils.redirect2Login();
        }
        $scope.model.domainList = [];
        for (var i = 0; i < domainList.length; i++) {
            if (domainCheck(domainList[i])) $scope.model.domainList.push(domainList[i]);
        }
        if ($scope.model.domainList.length <= 0) {
            iamUtils.redirect2Login();
        }
    }

    //校验是否合法
    function domainCheck(domainObj) {
        if (!domainObj.domain_name || !domainObj.domain_id || !domainObj.idp_id ) return false;
        var idps = domainObj.idp_id;
        domainObj.idp_id = [];
        for (var i = 0; i < idps.length; i++) {
            if (idps[i] && domainObj.idp_id.indexOf(idps[i]) === -1) domainObj.idp_id.push(idps[i]);
        }
        if (domainObj.idp_id.length <= 0) return false;
        return true;
    }





    SsologinController = ['$scope', 'securityPolicy', '$compile', '$interval', '$state', SsologinController];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.ssologin.ctrl', SsologinController);

    return SsologinController;
}
);


// WEBPACK FOOTER //
// ./public/hws/js/ssologin/controllers/ssologinController.js